import React from 'react';
import ServiceFeature from './ServiceFeature';

const ServiceInfo: React.FC = () => {
    const features = [
        { icon: '🚚', text: 'Livraison partout en France' },
        { icon: '💳', text: 'Paiement à la livraison' },
        { icon: '✅', text: 'Certification casher garantie' }
    ];

    return (
        <div>
            <h3 className="links-container-title">Service client</h3>
            <div className="space-y-4 text-sm text-gray-300">
                <div className="bg-gray-800 bg-opacity-50 p-3 rounded-lg border border-gray-700 hover:border-accent transition-colors duration-300">
                    <div className="flex items-center space-x-3 mb-2">
                        <span className="text-lg">⏰</span>
                        <span className="font-medium text-white">Horaires d'ouverture</span>
                    </div>
                    <div className="ml-6 space-y-1 text-xs">
                        <div>Lun-Jeu: 8h-17h</div>
                        <div>Vendredi: 8h-15h</div>
                    </div>
                </div>

                <div className="space-y-3">
                    {features.map((feature, index) => (
                        <ServiceFeature key={index} icon={feature.icon} text={feature.text} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceInfo;
